import React from 'react';
import local from 'services/localization/local';
import { ObservationType, Unit } from 'services/enums';
import { routePaths } from 'services/routing';
import { configIds } from 'health/observations/observation-config-ids';
import { baseObservationConfig } from 'health/observations/observation-config-helpers.jsx';
import { Arms } from 'shared/fullColorIcons';
import LogBodyArms from './log/LogBodyArms';

const typeDefinition = {
  type: ObservationType.BodyArms,
  typeUnitMap: {
    [ObservationType.BodyArms]: Unit.Inches
  },
  unitLabelMap: {
    [Unit.Inches]: local.units.inches
  }
};

export default {
  ...baseObservationConfig,
  ...typeDefinition,
  id: configIds.bodyArms,
  backPath: { to: routePaths.health },
  centerElement: local.observation.bodyArms.title,
  logcenterElement: local.observation.bodyChest.logTitle,
  noDataText: local.observation.bodyArms.noDataText,
  iconSymbol: Arms,
  renderLogComponent: (props) => props && <LogBodyArms {...props} />
};
